<template>
  <div class="ma-5">
    <div>
<!--      <SectionHeader></SectionHeader>-->
      <Breadcrumb></Breadcrumb>
    </div>
    <div>
      <div class="mt-10">
        <v-card class="mx-auto ma-5" max-width="700">
          <v-toolbar flat>
            <v-text-field
                outlined
                clearable
                :append-outer-icon="keyword ? 'search':''"
                v-model="keyword"
                label="Video Name"
                @click:append-outer="search"
                @keydown.enter.prevent="search"
            ></v-text-field>
          </v-toolbar>
        </v-card>
      </div>
    </div>
    <div class="mt-5">
      <div v-show="keyList.length !== 0">
        <!-- 历史记录 -->
        <div v-show="getKeyList.length !== 0">
          <v-container>
            <v-row>
              <v-col>
                <v-subheader>历史记录</v-subheader>
              </v-col>
              <v-col>
                <div class="text-right mt-2">
                  <v-icon @click="clearKeyList()">mdi-delete</v-icon>
                </div>
              </v-col>
            </v-row>
            <v-chip
                close
                @click:close="delKeyList({
                value : item.value,
              })"
                class="ma-3"
                v-for="(item,index) in getKeyList"
                :key="index"
                @click="keyword =  item.value"
            >
              {{ item.value }}
            </v-chip>
          </v-container>

        </div>
        <!-- 推荐 -->
        <div class="mt-5">
          <v-container>
            <v-row>
              <v-col v-for="(item,index) in keyList" :key="index" lg="6" cols="12">
                <v-card>
                  <v-card-title>
                    <v-subheader>{{ item.name }}</v-subheader>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-list-item v-for="(key,index) in item.list" :key="index"
                                 @click="toSearch(key)">
                      <v-list-item-icon>
                        <v-icon v-if="index < 3" style="color:red;">local_fire_department</v-icon>
                        <div v-else class="text-h6">
                          {{ index + 1 }}
                        </div>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ key.title }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content class="text-right font-italic">
                        <v-list-item-title>
                          <div class="ma-3">
                            {{ key.rate ? key.rate : '暂无' }}
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {hotKey} from "@/api/resources/video";
import {mapGetters, mapMutations} from "vuex";
// import SectionHeader from "@/components/video/SectionHeader";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "Search",
  data: () => ({
    keyword: undefined,
    keyList: [],
  }),
  mounted() {
    this.initKeyList()
  },
  computed: {
    ...mapGetters(['getNode', 'getKeyList']),
    isModel() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  components: {
    // SectionHeader,
    Breadcrumb
  },
  methods: {
    ...mapMutations(['clearKeyList', 'delKeyList', 'setKeyList', 'setLoading', 'clearLoading']),

    search() {
      if (!this.keyword) return;
      this.toResult(this.keyword);
    },

    toSearch({title}) {
      this.setKeyList({
        value: title,
        time: new Date().getTime()
      })
      this.toResult(title)
    },

    initKeyList() {
      this.setLoading()
      hotKey().then((req) => {
        this.keyList = req.data.data;
      }).finally(() => {
        this.clearLoading()
      })
    },
    toResult(vodName) {
      this.$router.push({
        path: '/video/result',
        query: {vodName: vodName}
      })
    }
  }
}
</script>

<style scoped>
.img-class {
  height: 250px;
  width: 180px;
}

.cover-class {
  height: 100%;
  width: 100%;
}
</style>
